import { PopupDialog } from "./popupDialog";
import "../assets/css/components.css";
import { TableList } from "./tableList";

export const TableListPreview = ({
  loading = false,
  isPreviewOpen = false,
  handlePreviewClose,
  content = [],
}) => {
  return (
    <PopupDialog
      name="richTextPreview"
      open={isPreviewOpen}
      onClose={() => {
        handlePreviewClose();
      }}
      neutralAction={handlePreviewClose}
      content={
        <TableList
          loading={loading}
          list={Array.isArray(content) ? content : [content]}
          isPreview={true}
          isEditable={false}
          deletePromise={() => {}}
        />
      }
    />
  );
};
